module.exports = __webpack_public_path__ + "media/application/images/ui/icon-masthead-mask-1b472e4c16f8c87b0f85a85a5cc29b55.png";